import type { ButtonGroupOption } from '../../../../components/react-hook-form/ButtonGroup';
import type { Phrases } from '../Phrases.d';

import React, { useEffect, useRef } from 'react';
import { useFormContext } from '../../../../components/react-hook-form/FormContext';
import { useWatch } from 'react-hook-form';
import { Fieldset } from '/react4xp/components/react-hook-form/Fieldset';
import { ColorButtonGroup } from './ColorButtonGroup';
import { ColorOtherTextField } from './ColorOtherTextField';
import {
	type SubstanceForm,
	COMMON_FIELD_NAME,
	SUBSTANCE_FORM,
} from '../constants';


const COLOR_LEGEND_ID = 'colorLegend';
const NASAL_SPRAY_OR_OTHER: string[] = [SUBSTANCE_FORM.NASAL_SPRAY, SUBSTANCE_FORM.OTHER];


export const ColorFieldset = ({
	capsuleContainerColorOptions,
	crystalColorOptions,
	liquidColorOptions,
	phrases,
	pillColorOptions,
	powderColorOptions,
}: {
	capsuleContainerColorOptions: ButtonGroupOption[];
	crystalColorOptions: ButtonGroupOption[];
	liquidColorOptions: ButtonGroupOption[];
	phrases: Phrases;
	pillColorOptions: ButtonGroupOption[];
	powderColorOptions: ButtonGroupOption[];
}): React.JSX.Element => {
	const {
		control,
		setScrollRef,
	} = useFormContext();
	const scrollRef = useRef();
	const substanceForm: SubstanceForm = useWatch({
		control,
		name: COMMON_FIELD_NAME.SUBSTANCE_FORM,
	}) as SubstanceForm;
	const showColorSelector = substanceForm && !NASAL_SPRAY_OR_OTHER.includes(substanceForm);
	const label = phrases[
		substanceForm === SUBSTANCE_FORM.PILL ? 'notificationForm.common.colorField.label.pill'
			: substanceForm === SUBSTANCE_FORM.CAPSULE ? 'notificationForm.common.colorField.label.capsuleContainer'
				: substanceForm === SUBSTANCE_FORM.CRYSTAL ? 'notificationForm.common.colorField.label.crystal'
					: substanceForm === SUBSTANCE_FORM.POWDER ? 'notificationForm.common.colorField.label.powder'
						: 'notificationForm.common.colorField.label.liquid'
	];

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({ field: COMMON_FIELD_NAME.COLOR_OTHER, el: scrollRef.current });
		}
	}, [scrollRef.current]);

	return (
		<Fieldset
			borderless
			className={showColorSelector ? undefined : 'hidden'}
			elementRef={scrollRef}
			legend={showColorSelector ? label : undefined}
			legendClassName='font-normal text-lg'
			legendId={COLOR_LEGEND_ID}
			name={COMMON_FIELD_NAME.COLOR}
		>
			<ColorButtonGroup
				aria-labelledby={COLOR_LEGEND_ID}
				capsuleContainerColorOptions={capsuleContainerColorOptions}
				crystalColorOptions={crystalColorOptions}
				liquidColorOptions={liquidColorOptions}
				phrases={phrases}
				pillColorOptions={pillColorOptions}
				powderColorOptions={powderColorOptions}
			/>
			<ColorOtherTextField
				colorLabel={label}
				phrases={phrases}
			/>
		</Fieldset>
	);
};
